import request from "@/utils/request";

// 导出采购需求信息V2
export async function apiExportPurchaseDemand (data) {
  return request({
    url: '/scp/scpSopPurchasePlanPool/v2/exportPurchaseDemand',
    method: 'post',
    data
  })
}

// 导出成品月计划单池表列表
export async function apiExportPurchasePlanPool (data) {
  return request({
    url: '/scp/scpSopPurchasePlanPool/export',
    method: 'post',
    data
  })
}

// 查询成品月计划单池表列表
export async function apiPurchasePlanPoolList (data) {
  return request({
    url: '/scp/scpSopPurchasePlanPool/list',
    method: 'post',
    data
  })
}

// 新增成品月计划单池表
export async function apiAddPurchasePlanPool (data) {
  return request({
    url: '/scp/scpSopPurchasePlanPool/add',
    method: 'post',
    data
  })
}

// 删除成品月计划单池表
export async function apiDeletePurchasePlanPool (ids) {
  return request({
    url: `/scp/scpSopPurchasePlanPool/deleteBatch`,
    method: 'post',
    data: ids
  })
}

// 提交成品月计划单池表
export async function apiSubmitPurchasePlanPool (params) {
  return request({
    url: `/scp/scpSopPurchasePlanPool/submit`,
    method: 'post',
    params
  })
}

// 成品月计划单池审核
export async function apiAuditPurchasePlanPool (params) {
  return request({
    url: `/scp/scpSopPurchasePlanPool/audit`, // ?ids=${params.ids}&status=${params.status}
    method: 'post',
    data: params
  })
}

// 成品月计划单池下发
export async function apiDeliveryPurchasePlanPool (params) {
  return request({
    url: `/scp/scpSopPurchasePlanPool/delivery`,
    method: 'post',
    params
  })
}

// 成品月计划单池作废
export async function apiCancelPurchasePlanPool (params) {
  return request({
    url: `/scp/scpSopPurchasePlanPool/cancel`,
    method: 'post',
    data: params
  })
}

// 创建采购需求
export async function apiCreatePurchaseDemand (data) {
  return request({
    url: '/scp/scpSopPurchasePlanPool/createPurchaseDemand',
    method: 'post',
    data
  })
}

// 确认计划单-获取签署的合同地址
export async function apiGetSignContractUrl (params) {
  return request({
    url: `/scp/scpSopPurchasePlanPool/ensureLS`,
    method: 'post',
    data: params
  })
}

// 更新
export async function apiUpdatePurchasePlanPool (data) {
  return request({
    url: '/scp/scpSopPurchasePlanPool/updateFields',
    method: 'post',
    data
  })
}

// 批量获取待变更单据弹窗列表
export async function apiGetPlanPoolChangeBillDetailList (data) {
  return request({
    url: '/scp/scpSopPurchasePlanPool/getPlanPoolChangeBillDetailList',
    method: 'post',
    data
  })
}

// 确认提交变更单
export async function apiConfirmPlanPoolChangeBill (data) {
  return request({
    url: '/scp/scpSopPurchasePlanPool/confirmPlanPoolChangeBill',
    method: 'post',
    data
  })
}

// 查看变更详情
export async function getPoolQueryBySourceRowId (params) {
  return request({
    url: '/scp/scpSopPurchasePlanPool/queryBySourceRowId',
    method: 'get',
    params
  })
}

// 获取阶梯价格
export async function apiGetPlanPoolPriceDetailList (data) {
  return request({
    url: '/scp/scpSopPurchasePlanPool/getPlanPoolPriceDetailList',
    method: 'post',
    data
  })
}

// 获取供应商
export async function getAssessorGetList (params) {
  return request({
    url: '/scp/scpSopPurchasePlanPool/assessor/getList',
    method: 'get',
    params
  })
}

// 获取变更原因
export async function getChangeReasonList (params) {
  return request({
    url: '/scp/scpSopPurchasePlanPool/changeReason/getList',
    method: 'get',
    params
  })
}

// 日志 type=12
export async function getPurchasePlanPoolLogApi (params) {
  return request({
    url: '/mes/mesWipLog/selectMesWipCommonLogs',
    method: 'get',
    params
  })
}

// 关联采购订单
export async function getPurchasePlanPoolOrderApi (params) {
  return request({
    url: `/scp/scpSopPurchasePlanPool/getPurchaseDemandDetail/${params.id}`,
    method: 'get'
  })
}

// 获取模板
export async function apiGetTemplate () {
  return request({
    url: `/scp/scpSopPurchasePlanPool/template`,
    method: 'get'
  })
}

// 获取采购需求模板
export async function apiGetPurchaseDemandTemplate () {
  return request({
    url: `/scp/scpSopPurchasePlanPool/purchaseDemandTemplate`,
    method: 'post'
  })
}

// 批量更新物料信息
export async function apiBatchUpdateItemInfo (data) {
  return request({
    url: '/scp/scpSopPurchasePlanPool/batchUpdateItemInfo',
    method: 'post',
    data
  })
}
